import Paper from '@mui/material/Paper';
import { node } from 'prop-types';
import React from 'react';

const paperSx = {
  padding: '1.5em',
  margin: '1em 0',
  boxShadow:
    '0px 11px 15px -7px rgba(0,0,0,0.05), ' +
    '0px 24px 38px 3px rgba(0,0,0,0.02), ' +
    '0px 9px 46px 8px rgba(0,0,0,0.01)',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
};

const CustomPaper = ({ children }) => (
  <Paper sx={paperSx} elevation={24}>
    {children}
  </Paper>
);
CustomPaper.propTypes = {
  children: node.isRequired,
};

export default CustomPaper;
